import React from "react";
import "./styles/Home.css"; // Global styles

// Import all components
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import Education from "./components/Education";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Achievements from "./components/Achievements";
import Resume from "./components/Resume";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
    return (
        <div className="App">
            <Navbar />
            <div id="home">
                <Home />
            </div>
            <About />
            <Education />
            <Skills />
            <Projects />
            <Achievements />
            <Resume />
            <Contact />
            <Footer />
        </div>
    );
}

export default App;